// localhost
// const BASE_URL = "http://127.0.0.1:8686/v1/api";

// dev domain
// const BASE_URL = "http://3.111.109.92:8686/v1/api";

// live domain
export const BASE_URL = "https://api.furniba.in/v1/api";

export const API_LOGIN_ADMIN = BASE_URL + "/admin/login";
export const API_GET_ADMINS_DATA = BASE_URL + "/admin";
export const API_INSERT_ADMIN_DATA = BASE_URL + "/admin";
export const API_UPDATE_CURRENT_ADMIN_DATA = BASE_URL + "/admin/update-current-admin-data";
export const API_UPDATE_ADMIN_DATA = BASE_URL + "/admin";
export const API_TOGGLE_ADMIN_DATA = BASE_URL + "/admin";

export const API_GET_USERS_DATA = BASE_URL + "/user/get-users-data";
export const API_INSERT_USER_DATA = BASE_URL + "/user/insert-user-data";
export const API_UPDATE_USER_DATA = BASE_URL + "/user/update-user-data";
export const API_TOGGLE_USER_DATA = BASE_URL + "/user/toggle-user-data";

export const API_GET_BLOG_DATA = BASE_URL + "/blog/get-blog-data";
export const API_INSERT_BLOG_DATA = BASE_URL + "/blog/insert-blog-data";
export const API_UPDATE_BLOG_DATA = BASE_URL + "/blog/update-blog-data";
export const API_TOGGLE_BLOG_DATA = BASE_URL + "/blog/toggle-blog-data";

export const API_GET_TESTIMONIAL_DATA = BASE_URL + "/testimonial/get-testimonial-data";
export const API_INSERT_TESTIMONIAL_DATA = BASE_URL + "/testimonial/insert-testimonial-data";
export const API_UPDATE_TESTIMONIAL_DATA = BASE_URL + "/testimonial/update-testimonial-data";
export const API_TOGGLE_TESTIMONIAL_DATA = BASE_URL + "/testimonial/toggle-testimonial-data";

export const API_GET_SLIDERS_DATA = BASE_URL + "/slider/get-sliders-list-data";
export const API_GET_SLIDER_TYPE_DATA = BASE_URL + "/slider/get-slider-type-data";
export const API_INSERT_SLIDER_DATA = BASE_URL + "/slider/insert-slider-data";
export const API_ADD_SLIDER_IMAGE = BASE_URL + "/slider/add-slider-image";
export const API_UPDATE_SLIDER_DATA = BASE_URL + "/slider/update-slider-data";
export const API_TOGGLE_SLIDER_DATA = BASE_URL + "/slider/toggle-slider-data";
export const API_TOGGLE_PRODUCT_SLIDER_PRODUCT = BASE_URL + "/slider/toggle-product-slider-product";

export const API_GET_ORDERS_DATA = BASE_URL + "/order/get-orders-data";
export const API_INSERT_ORDER_DATA = BASE_URL + "/order/insert-order-data";
export const API_UPDATE_ORDER_STATUS = BASE_URL + "/order/update-order-status";
export const API_TOGGLE_ORDER_DATA = BASE_URL + "/order/toggle-order-data";
export const API_GET_ANALYTICS_DATA = BASE_URL + "/order/get-analytics-data";
export const API_GET_ORDER_ANALYTICS = BASE_URL + "/order/get-order-analytics";

// export const API_INSERT_ANALYTIC_DATA = BASE_URL + "/analytic/insert-analytic-data";
// export const API_UPDATE_ANALYTIC_DATA = BASE_URL + "/analytic/update-analytic-data";
// export const API_TOGGLE_ANALYTIC_DATA = BASE_URL + "/analytic/toggle-analytic-data";

export const API_GET_BRAND_DATA = BASE_URL + "/brand/get-brands-data";
export const API_INSERT_BRAND_DATA = BASE_URL + "/brand/insert-brand-data";
export const API_UPDATE_BRAND_DATA = BASE_URL + "/brand/update-brand-data";
export const API_TOGGLE_BRAND_DATA = BASE_URL + "/brand/toggle-brand-data";

export const API_GET_USER_TYPE_DATA = BASE_URL + "/user-type/get-user-types-data";
export const API_INSERT_USER_TYPE_DATA = BASE_URL + "/user-type/insert-user-type-data";
export const API_UPDATE_USER_TYPE_DATA = BASE_URL + "/user-type/update-user-type-data";
export const API_TOGGLE_USER_TYPE_DATA = BASE_URL + "/user-type/toggle-user-type-data";

export const API_GET_CITY_DATA = BASE_URL + "/city/get-city-data";
export const API_INSERT_CITY_DATA = BASE_URL + "/city/insert-city-data";
export const API_UPDATE_CITY_DATA = BASE_URL + "/city/update-city-data";
export const API_TOGGLE_CITY_DATA = BASE_URL + "/city/toggle-city-data";

export const API_GET_STORE_DATA = BASE_URL + "/store/get-store-data";
export const API_INSERT_STORE_DATA = BASE_URL + "/store/insert-store-data";
export const API_UPDATE_STORE_DATA = BASE_URL + "/store/update-store-data";
export const API_TOGGLE_STORE_DATA = BASE_URL + "/store/toggle-store-data";

export const API_GET_PRODUCT_CATEGORIES_BAR_DATA = BASE_URL + "/product-category-bar/get-product-categories-bar-data";
export const API_INSERT_PRODUCT_CATEGORY_BAR_DATA = BASE_URL + "/product-category-bar/insert-product-category-bar-data";
export const API_UPDATE_PRODUCT_CATEGORY_BAR_DATA = BASE_URL + "/product-category-bar/update-product-category-bar-data";
export const API_TOGGLE_PRODUCT_CATEGORY_BAR_DATA = BASE_URL + "/product-category-bar/toggle-product-category-bar-data";

export const API_GET_PRODUCT_CATEGORIES_DATA = BASE_URL + "/product-category/get-product-categories-data";
export const API_GET_PRODUCT_CATEGORIES_BY_BAR_DATA = BASE_URL + "/product-category/get-product-categories-by-bar-data";
export const API_INSERT_PRODUCT_CATEGORY_DATA = BASE_URL + "/product-category/insert-product-category-data";
export const API_UPDATE_PRODUCT_CATEGORY_DATA = BASE_URL + "/product-category/update-product-category-data";
export const API_TOGGLE_PRODUCT_CATEGORY_DATA = BASE_URL + "/product-category/toggle-product-category-data";

export const API_GET_PRODUCT_SUB_CATEGORIES_DATA = BASE_URL + "/product-sub-category/get-product-sub-categories-data";
export const API_GET_PRODUCT_SUB_CATEGORIES_BY_CATEGORY_DATA = BASE_URL + "/product-sub-category/get-product-sub-categories-by-category-data";
export const API_INSERT_PRODUCT_SUB_CATEGORY_DATA = BASE_URL + "/product-sub-category/insert-product-sub-category-data";
export const API_UPDATE_PRODUCT_SUB_CATEGORY_DATA = BASE_URL + "/product-sub-category/update-product-sub-category-data";
export const API_TOGGLE_PRODUCT_SUB_CATEGORY_DATA = BASE_URL + "/product-sub-category/toggle-product-sub-category-data";

export const API_GET_ATTRIBUTES_DATA = BASE_URL + "/attribute/get-attributes-data";
export const API_GET_ATTRIBUTES_BY_PRODUCT_DATA = BASE_URL + "/attribute/get-attributes-by-product-data";
export const API_INSERT_ATTRIBUTE_DATA = BASE_URL + "/attribute/insert-attributex-data";
export const API_UPDATE_ATTRIBUTE_DATA = BASE_URL + "/attribute/update-attribute-data";
export const API_TOGGLE_ATTRIBUTE_DATA = BASE_URL + "/attribute/toggle-attribute-data";

export const API_GET_FINISHES_DATA = BASE_URL + "/attribute/get-finishes-data";
export const API_INSERT_FINISH_DATA = BASE_URL + "/attribute/insert-finish-data";
export const API_UPDATE_FINISH_DATA = BASE_URL + "/attribute/update-finish-data";

export const API_GET_SIZES_DATA = BASE_URL + "/attribute/get-sizes-data";
export const API_INSERT_SIZE_DATA = BASE_URL + "/attribute/insert-size-data";
export const API_UPDATE_SIZE_DATA = BASE_URL + "/attribute/update-size-data";

export const API_GET_STORAGES_DATA = BASE_URL + "/attribute/get-storages-data";
export const API_INSERT_STORAGE_DATA = BASE_URL + "/attribute/insert-storage-data";
export const API_UPDATE_STORAGE_DATA = BASE_URL + "/attribute/update-storage-data";

export const API_GET_COLORS_DATA = BASE_URL + "/attribute/get-colors-data";
export const API_INSERT_COLOR_DATA = BASE_URL + "/attribute/insert-color-data";
export const API_UPDATE_COLOR_DATA = BASE_URL + "/attribute/update-color-data";

export const API_GET_MATERIALS_DATA = BASE_URL + "/attribute/get-materials-data";
export const API_INSERT_MATERIAL_DATA = BASE_URL + "/attribute/insert-material-data";
export const API_UPDATE_MATERIAL_DATA = BASE_URL + "/attribute/update-material-data";

export const API_GET_PRODUCTS_DATA = BASE_URL + "/product/get-products-data";
export const API_INSERT_PRODUCT_DATA = BASE_URL + "/product/insert-product-data";
export const API_UPDATE_PRODUCT_DATA = BASE_URL + "/product/update-product-data";
export const API_TOGGLE_PRODUCT_DATA = BASE_URL + "/product/toggle-product-data";
export const API_TOGGLE_PRODUCT_FEATURE_DATA = BASE_URL + "/product/toggle-product-feature-data";
export const API_GET_PRODUCT_IMAGE_DATA = BASE_URL + "/product/get-product-images-data"
export const API_INSERT_PRODUCT_IMAGE_DATA = BASE_URL + "/product/insert-product-image-data"
export const API_DELETE_PRODUCT_IMAGE_DATA = BASE_URL + "/product/delete-product-image-data"

export const API_GET_PRODUCT_CONFIGS_DATA = BASE_URL + "/product/get-product-configs-data";
export const API_GET_PRODUCT_CONFIGS_BY_PRODUCTS_DATA = BASE_URL + "/product/get-product-configs-by-products-data";
export const API_INSERT_PRODUCT_CONFIG_DATA = BASE_URL + "/product/insert-product-config-data";
export const API_UPDATE_PRODUCT_CONFIG_DATA = BASE_URL + "/product/update-product-config-data";
export const API_TOGGLE_PRODUCT_CONFIG_DATA = BASE_URL + "/product/toggle-product-config-data";

export const API_GET_REVIEWS_DATA = BASE_URL + "/review/get-reviews-data";
export const API_GET_REVIEWS_BY_PRODUCT_DATA = BASE_URL + "/review/get-reviews-by-product-data";
export const API_INSERT_REVIEW_BY_PRODUCT_DATA = BASE_URL + "/review/insert-review-by-product-data";
export const API_UPDATE_REVIEW_DATA = BASE_URL + "/review/update-review-data";
export const API_TOGGLE_REVIEW_DATA = BASE_URL + "/review/toggle-review-data";

export const API_GET_COUNTS_DATA = BASE_URL + "/count/get-counts-data";
